import React from 'react';
import Modal, { ModalBody, ModalFooter, ModalHeader, ModalTitle, ModalTransition } from '@atlaskit/modal-dialog';
import Button from '@atlaskit/button';

type MatchBillDatesWarningModalProps = {
  closeModal: () => void;
  openSidebar: () => void;
};

export const MatchBillDatesWarningModal: React.FC<MatchBillDatesWarningModalProps> = ({ closeModal, openSidebar }) => {
  return (
    <ModalTransition>
      <Modal onClose={closeModal} isBlanketHidden={false} width={'medium'} testId="match-bill-date-warning-modal">
        <ModalHeader>
          <ModalTitle appearance="warning">This action will affect other subscriptions</ModalTitle>
        </ModalHeader>
        <ModalBody>
          <>
            <p>
              Products and apps on the same site that belong to the same product family need to be billed together, so
              they’ll need to have the same new bill date. They’ll be automatically included in your order.
            </p>
            <br />
            <p>Pro-rated adjustments will be applied to the next invoice.</p>
          </>
        </ModalBody>
        <ModalFooter>
          <Button testId="modal-cancel-cta" appearance="subtle" onClick={closeModal}>
            Cancel
          </Button>
          <Button testId="modal-continue-cta" appearance="warning" onClick={openSidebar} autoFocus>
            Continue
          </Button>
        </ModalFooter>
      </Modal>
    </ModalTransition>
  );
};
